import React from 'react'
import { Row, Col } from "react-bootstrap"
import "./Faq.css"
import Carosel from "./Carosel"
function Faq() {
    return (
        <>
            <div className="container faq_main" id="faq">
                <div>
                    <h3 className="faq_know">BRRRRRR</h3>
                </div>

                <div className="faq_col">
                    <Row>
                        <Col xl={6} lg={6} md={12} sm={12} xs={12} className="col-one">
                            <Carosel />
                        </Col>
                        <Col xl={6} lg={6} md={12} sm={12} xs={12} className="col-two">

                            <h3 className="faq">F.A.Q.</h3>
                            <h4 className="content">What is the total supply?</h4>
                            <h4 className="content">A total of 10,000 unique sevens NFTs will be created.</h4>
                            <h4 className="content">When is the launch?</h4>
                            <h4 className="content">TBA.</h4>
                            <h4 className="content">How much does it cost to mint an NFT?</h4>
                            <h4 className="content">1 SOL.</h4>
                            <h4 className="content">Will there be a pre-sale?</h4>
                            <h4 className="content">We will make sure that active community
                                members will be rewarded.</h4>
                            <h4 className="content">Have more questions? Come through to our <a target='_blank' href="https://discord.gg/XYRkqRg9" className="anker">Discord </a>
                                to learn more.</h4>


                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}

export default Faq
